import { Entity, IEntity } from "./Entity";
import { IRiskAppIncident } from "./RiskAppIncident";

export interface IRiskAppIncidentSystem extends IEntity {
    SystemID?: number;
    IncidentID?: number;
    System?: IEntity;
    Incident?: IRiskAppIncident;
}

export class RiskAppIncidentSystem extends Entity implements IRiskAppIncidentSystem {
    public SystemID = null;
    public IncidentID = null;
}